import React, { FC } from 'react'
import { Circle, StatusIconWrapper } from './Status.style'

export type StatusType = 'everythingOK' | 'waiting' | 'none' | 'past' | 'all'

interface StatusIconProps {
  type: StatusType
}

const StatusIcon: FC<StatusIconProps> = ({ type }) => {
  return (
    <StatusIconWrapper>
      <Circle type={type} />
      <Circle isInnerCircle type={type} />
    </StatusIconWrapper>
  )
}

export default StatusIcon
